import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { FreshAuthService } from '../fresh-auth.services';
import { Router, ActivatedRoute } from '@angular/router';
import { FruitsServiceService } from 'app/laas/fruits-land-record/fruits-service.service';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import * as constants from 'app/constant';
@Component({
  selector: 'wl-validation-card',
  templateUrl: './validation-card.component.html',
  styleUrls: ['./validation-card.component.css']
})
export class ValidationCardComponent implements OnInit {

  custId: string;
  // Shown in the header's place when the application has no customer ID —
  // an NTB applicant has no CBS record yet, so the mobile is all there is.
  mobileNo: string;
  custName: string;
  status: string = ""

  isChecker: boolean = false; 
  enteredLandArea?: number;
  isChecked?: boolean;
  appId: string;
  state : string;

  validationForm: UntypedFormGroup;
  isFormReady = false;
  checkerAction:boolean=false;
  maker_id:string;
  maker_status:string = "";
  // 'maker' | 'checker', stored at login by AdminAuthService.storeAdmin.
  approvalStage: string = "";
  loading: boolean = false;

  // Which land record the detail pane is showing. The others stay rendered but
  // hidden, so every control keeps its place in the FormArray and nothing
  // half-entered is lost by moving between records.
  activeIndex: number = 0;

  consentFile: File = null;
  consentFileError: string = "";

  // 5MB, tighter than the server's own 20MB ceiling — oversized files are
  // turned away here so nobody waits out an upload only to be rejected.
  static readonly CONSENT_MAX_BYTES = 5 * 1024 * 1024;

  consentDocs: any[] = [];

  // referenceId currently being fetched, so its own button can say so without
  // the other row's button changing too.
  openingDocRef: string = "";

  // All land records, BRE-passed first. Index-aligned with the applicants array.
  apiFiles: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private authService: FreshAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private fruitsService: FruitsServiceService,
    private dialog: MatDialog
  ) { }

  // sessionStorage stores a missing value as the literal "undefined" or
  // "null", both of which are truthy and would print straight onto the card.
  // Treat them as absent so *ngIf can fall through to the mobile number.
  private sessionValue(key: string): string {

    const value = sessionStorage.getItem(key);

    if (!value || value === 'undefined' || value === 'null') return '';

    return value;

  }

  ngOnInit() {

    this.custId = this.sessionValue('selectedCustId');
    this.mobileNo = this.sessionValue('selectedMobileNo');
    this.custName = sessionStorage.getItem('selectedName');
    // this.status = sessionStorage.getItem('selectedStatus');
    this.appId = sessionStorage.getItem('selectedId');
    this.maker_status=sessionStorage.getItem('maker_status');

    // Who is looking at this card is decided by the logged-in user's own
    // approvalStage, not by how far the application has travelled. Normalised
    // the same way the Branch Validation Inbox and navigation.ts do it.
    this.approvalStage = (sessionStorage.getItem('approvalStage') || '').trim().toLowerCase();
    this.isChecker = this.approvalStage === 'checker';

    this.loadApplicants();

  }

loadApplicants() {

  this.isFormReady = false;

  // ✅ create form
  // Built BEFORE the request, not after, because the template binds
  // [formGroup]="validationForm" as soon as isFormReady flips. Every path that
  // sets isFormReady — success, a success:false body (an expired session sends
  // one), or a transport error — must therefore leave a real FormGroup here, or
  // the formGroup directive receives undefined and throws on every change
  // detection pass.
  //
  // Remarks live on each applicant (land record), for the checker exactly as
  // they already did for the maker, because /checkerconsent carries them per
  // record the same way /makerconsent does.
  this.validationForm = this.fb.group({
    applicants: this.fb.array([])
  });

  this.fruitsService.getApplicantData({appId: this.appId}).subscribe(res => {

    this.state= res && res.result && res.result.state ? res.result.state : null;

    if (!(res && res.success && res.result)) {
      console.error("Could not load applicant data:", res);
      this.handleLoadFailure(res);
      return;
    }

    const apiResponse = res.result

    console.log("API Response:", apiResponse);

    // ✅ correct appId assignment
    this.appId = apiResponse.id;

    // Missing entirely on older applications, hence the array guard rather than
    // a truthiness check — the template iterates this.
    this.consentDocs = Array.isArray(apiResponse.landConsentDocs)
      ? apiResponse.landConsentDocs
      : [];

    const applicantsArray = this.getApplicants();

    let files = [];

    if (
      apiResponse.docs &&
      apiResponse.docs.assets &&
      apiResponse.docs.assets.bhoomi &&
      apiResponse.docs.assets.bhoomi.files
    ) {
      files = apiResponse.docs.assets.bhoomi.files;
    }

    // Passed records first, then the failed ones needing a verdict.
    const failedFiles = files.filter(file => (file.land_bre_status || "").toLowerCase() === "failure");
    const passedFiles = files.filter(file => (file.land_bre_status || "").toLowerCase() === "success");

    this.apiFiles = passedFiles.concat(failedFiles);

    // ✅ loop files
    this.apiFiles.forEach(file => {

      let surveyNo = "-";
      let totalArea = 0;

      if (constants.STATES.OD.POSSIBILITIES.includes((this.state || '').toLowerCase())) {
        // Odisha mapping
        surveyNo =
            file.land_details?.data?.data?.documentDetails?.surveyNumbers?.[0] || "-";
        }
      else if (constants.STATES.TN.POSSIBILITIES.includes((this.state || '').toLowerCase())) {
        // Tamil Nadu mapping. One survey number, not the array Odisha sends,
        // and it arrives space-padded ("57    ") so it is trimmed before use.
        surveyNo =
            String(file.land_details?.data?.data?.documentDetails?.surveyno || "").trim() || "-";
        }
      else if (constants.STATES.MP.POSSIBILITIES.includes((this.state || '').toLowerCase())) {
        // Madhya Pradesh mapping. `file` is one incomingMultipleKasra entry, so
        // the survey (khasra) number is the one the applicant sent in, echoed
        // back on input.parcel_no — not on landParcelDetails.surveyNo, which MP
        // does not populate.
        const parcelNo = file.input?.parcel_no;
        surveyNo = (Array.isArray(parcelNo) ? parcelNo[0] : parcelNo) || "-";
        }
      else if (
        file.land_details &&
        file.land_details.landParcelDetails &&
        file.land_details.landParcelDetails.length > 0
      ) {

        const parcel = file.land_details.landParcelDetails[0];

      if (parcel.surveyNo && parcel.surveyNo.length > 0)
        surveyNo = parcel.surveyNo[0];

      }

      if (constants.STATES.RJ.POSSIBILITIES.includes((this.state || '').toLowerCase())||constants.STATES.MP.POSSIBILITIES.includes((this.state || '').toLowerCase())||constants.STATES.GJ.POSSIBILITIES.includes((this.state || '').toLowerCase())
        ||constants.STATES.MH.POSSIBILITIES.includes((this.state || '').toLowerCase())) {
        // Rajasthan mapping
        totalArea = Number(
            file.land_details?.landParcelDetails?.[0]?.surveyNoArea?.[0] || 0
        );
        } else if (constants.STATES.OD.POSSIBILITIES.includes((this.state || '').toLowerCase())) {
        // Odisha mapping
        totalArea = Number(
            file.land_details?.data?.data?.landOwnerDetails?.[0]?.owner?.hissa || 0
        );
        } else if (constants.STATES.TN.POSSIBILITIES.includes((this.state || '').toLowerCase())) {
        // Tamil Nadu mapping. owner.hissa is always blank here, so the area is
        // taken off the parcel itself.
        totalArea = Number(
            file.land_details?.data?.data?.landOwnerDetails?.[0]?.landParcel?.cultiarea || 0
        );
        } else {
        // Existing state mapping
       
       if (
        file.ownershipdetails &&
        file.ownershipdetails.ownerDetails &&
        file.ownershipdetails.ownerDetails.length > 0 &&
        file.ownershipdetails.ownerDetails[0].ownerDetails &&
        file.ownershipdetails.ownerDetails[0].ownerDetails.length > 0
        ) {
        totalArea = Number(
            file.ownershipdetails.ownerDetails[0].ownerDetails[0].hissa
            );
        }
    }
      const usersArray = this.fb.array([]);

      // Profile Match
      usersArray.push(this.createUserGroup({
        Error: 'name',
        label: 'Profile Match',
        failed: file.bhoomi_details.profile_match === 0,
        cbsName: file.name2 || "-",
        name:
        file.name_match_details &&~
        file.name_match_details.converted_name
          ? file.name_match_details.converted_name
          : "-"
      }));

      // Land Area
       let hasZeroShare = Number(totalArea) === 0;

        usersArray.push(this.createUserGroup({
        Error: 'land',
        label: 'Land Area',
        failed: hasZeroShare,
        LandArea: totalArea
        }));

      // Court Case
      usersArray.push(this.createUserGroup({
        Error: 'court',
        label: 'Court Case',
        failed: file.isCourtCase === true
      }));

      // Irrigation
      usersArray.push(this.createUserGroup({
        Error: 'irrigation',
        label: 'Irrigation',
        failed: file.isIrrigated === false
      }));

      // Mortgage
      usersArray.push(this.createUserGroup({
        Error: 'mortgage',
        label: 'Mortgage',
        failed: file.isMortgage === true
      }));

      const applicantGroup = this.fb.group({

  Survey_No: surveyNo,
  Area: totalArea,
  // 'success' = BRE passed: read-only, never submitted.
  breStatus: (file.land_bre_status || "").toLowerCase(),
  decision: null,
  makerRemarks: [''],
  // Checker's own verdict on this land record, kept separate from the maker's
  // so both can be shown side by side and sent independently.
  checkerDecision: null,
  checkerRemarks: [''],
  Users: usersArray

});

console.log("this.isChecker",this.isChecker);


if (this.isChecker && file.bank_review &&file.bank_review.maker) {

  var review = file.bank_review.maker;
  var modified = review.modified_data || {};
  var current = review.current_data || {};
  var overallStatus = review.overall_status;

  var users = applicantGroup.get('Users') as UntypedFormArray;

for (var i = 0; i < users.controls.length; i++) {

  var user = users.controls[i];
  var errorType = user.get('Error').value;

  if (overallStatus === 'rejected') {

    user.get('isChecked').setValue(false);
    continue;

  }

  if (overallStatus === 'approved') {

    if (errorType === 'name') {

      if (modified.profile_match !== current.profile_match)
        user.get('isChecked').setValue(true);

    }

    else if (errorType === 'land') {

      if (modified.landArea !== current.landArea) {

        user.get('enteredLandArea').setValue(modified.landArea);
        user.get('isChecked').setValue(true);

      }

    }

    else if (errorType === 'court') {

      if (modified.isCourtCase !== current.isCourtCase)
        user.get('isChecked').setValue(true);

    }

    else if (errorType === 'irrigation') {

      if (modified.isIrrigated !== current.isIrrigated)
        user.get('isChecked').setValue(true);

    }

    else if (errorType === 'mortgage') {

      if (modified.isMortgage !== current.isMortgage)
        user.get('isChecked').setValue(true);

    }

  }

}
  applicantGroup.get('decision').setValue(overallStatus);

  if (review.makerRemarks) {
    applicantGroup.get('makerRemarks').setValue(review.makerRemarks);
  }

}

applicantsArray.push(applicantGroup);
// ✅ Push to FormArray
console.log("applicantsArray",applicantsArray);

    });

    if (this.isChecker) {
      // Lock the whole form (this is the maker's work, replayed) and then hand
      // the checker back only their own controls.
      this.validationForm.disable();
      this.enableCheckerControls();
    }

    this.isFormReady = true;

    this.cd.detectChanges();

  },
  err => {
    console.error("API error:", err);
    this.handleLoadFailure(err && err.error);
  });

}

private handleLoadFailure(body: any): void {

  this.isFormReady = true;
  this.cd.detectChanges();

  if (body && (body.sessionExpired === true || body.reason === 'SESSION_EXPIRED')) {
    return;
  }

  const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
    width: '440px',
    disableClose: true,
    data: {
      heading: "",
      content: "Could not load the land records for this application.",
      content1: "Please try again from the Branch Validation Inbox.",
      button1Text: "OK",
      button2Text: ""
    }
  });

  dialogRef.afterClosed().subscribe(() => {
    this.router.navigate(['/fresh-app/view-review-journey']);
  });

}



createUserGroup(data): UntypedFormGroup {

  const isLandError = data.Error === 'land';
  const isFailed = data.failed === true;

  const landValidators = isLandError && isFailed
    ? [
        Validators.required,
        Validators.min(0.0001),
        Validators.max(10),
        Validators.pattern(/^\d*\.?\d*$/)
      ]
    : [];

  const group = this.fb.group({

    Error: data.Error,
    label: data.label,

    failed: isFailed,

    name: data.name || null,
    cbsName: data.cbsName || null,
    LandArea: data.LandArea || null,

    enteredLandArea: [null, landValidators],

    // ✅ FIX: Always disabled initially for land error
    isChecked: new UntypedFormControl({
      value: false,
      disabled: isLandError ? true : !isFailed
    }),

    // ---------- CHECKER SIDE ----------
    // Mirror of the two maker controls above. The maker's pair is shown locked
    // to the checker; this pair is the checker's own input on the same check.
    checkerEnteredLandArea: [null, landValidators],

    checkerIsChecked: new UntypedFormControl({
      value: false,
      disabled: isLandError ? true : !isFailed
    })

  });


  // ✅ Enable checkbox ONLY when valid value entered
  if (isLandError && isFailed) {

    this.bindLandAreaToCheckbox(
      group.get('enteredLandArea'),
      group.get('isChecked')
    );

    this.bindLandAreaToCheckbox(
      group.get('checkerEnteredLandArea'),
      group.get('checkerIsChecked')
    );

  }

  return group;
}

private bindLandAreaToCheckbox(landControl, checkboxControl): void {

  landControl.valueChanges.subscribe(value => {

    const num = Number(value);

    if (
      value !== null &&
      value !== '' &&
      !isNaN(num) &&
      num > 0 &&
      num <= 10
    ) {

      checkboxControl.enable();

    } else {

      checkboxControl.disable();
      checkboxControl.setValue(false);

    }

  });

}

getConfirmationText(label: string): string {
  switch (label) {
    case 'Profile Match':
      return 'Requested owner name and Land owner name are same';

    case 'Land Area':
      return 'Confirm the land area entered is correct';

    case 'Mortgage':
      return 'Confirm Mortgage will be resolved before loan approval';

      case 'Irrigation':
      return 'Confirm Irrigation will be resolved before loan approval';

      case 'Court Case':
      return 'Confirm court case will be resolved before loan approval';

    default:
      return 'Confirm ' + label;
  }
}

  // ---------- GETTERS ----------

  getApplicants(): UntypedFormArray {
    return this.validationForm.get('applicants') as UntypedFormArray;
  }

  // True for BRE-passed records, which render without any controls.
  isReadOnlyRecord(applicantIndex: number): boolean {

    const applicant = this.getApplicants().at(applicantIndex);

    return !!applicant && applicant.get('breStatus').value === 'success';

  }

  // Only the records needing a verdict.
  private reviewableApplicants(): AbstractControl[] {

    return this.getApplicants().controls.filter(
      applicant => applicant.get('breStatus').value !== 'success'
    );

  }

  // Hides the action bars when every record passed.
  hasReviewableRecords(): boolean {
    return this.reviewableApplicants().length > 0;
  }

  getUsers(applicantIndex: number): UntypedFormArray {
    return this.getApplicants().at(applicantIndex).get('Users') as UntypedFormArray;
  }

  // False when the load failed or the application has nothing to review. The
  // action bars hang off this so they can never submit an empty land_data.
  hasRecords(): boolean {
    return this.getApplicants().controls.length > 0;
  }

  // ---------- RECORD SELECTION ----------
  // Presentation only — which record is on screen. Nothing here touches a
  // decision, a control's value or its enabled state.

  selectRecord(index: number): void {

    if (index < 0 || index >= this.getApplicants().length) return;

    this.activeIndex = index;

  }

  // The verdict that belongs to whoever is looking: the maker sees their own,
  // the checker sees theirs. Drives the status chip in the record list.
  recordState(applicantIndex: number): string {

    const applicant = this.getApplicants().at(applicantIndex);

    if (!applicant) return 'pending';

    // Passed records have no verdict.
    if (applicant.get('breStatus').value === 'success') return 'success';

    const decision = this.isChecker
      ? applicant.get('checkerDecision').value
      : applicant.get('decision').value;

    return decision || 'pending';

  }

  decidedCount(): number {

    return this.getApplicants().controls
      .filter((applicant, index) => this.recordState(index) !== 'pending')
      .length;

  }

  // ---------- CHECKER CONTROL ENABLING ----------

  private enableCheckerControls(): void {

    this.getApplicants().controls.forEach((applicant, applicantIndex) => {

      // Nothing to enable on a passed record.
      if (applicant.get('breStatus').value === 'success') return;

      applicant.get('checkerDecision').enable();
      applicant.get('checkerRemarks').enable();

      this.getUsers(applicantIndex).controls.forEach(user => {

        // A check the BRE passed needs no confirmation from anybody.
        if (!user.get('failed').value) return;

        if (user.get('Error').value === 'land') {

          user.get('checkerEnteredLandArea').enable();

        } else {

          user.get('checkerIsChecked').enable();

        }

      });

    });

  }

  // ---------- CHECKBOX ENABLE LOGIC ----------

  isCheckboxDisabled(applicantIndex: number, userIndex: number): boolean {

    // the maker's own controls are read-only once a checker is looking
    if (this.isChecker) return true;

    const userGroup = this.getUsers(applicantIndex).at(userIndex);

    // only apply rule for land error
    if (userGroup.get('Error').value === 'land') {

      const value = userGroup.get('enteredLandArea').value;

      // disable checkbox if value is null, undefined, empty, or <= 0
      return (
        value === null ||
        value === undefined ||
        value === '' ||
        Number(value) <= 0
      );
    }

    // for name error, checkbox is enabled
    return false;
  }
  // ---------- APPROVE BUTTON ENABLE ----------

 allChecked(applicantIndex: number): boolean {

  const users = this.getUsers(applicantIndex);

  return users.controls
    .filter(user => user.get('failed').value === true)
    .every(user => user.get('isChecked').value === true);

}

// Same gate as allChecked(), read off the checker's own checkboxes.
allCheckerChecked(applicantIndex: number): boolean {

  const users = this.getUsers(applicantIndex);

  return users.controls
    .filter(user => user.get('failed').value === true)
    .every(user => user.get('checkerIsChecked').value === true);

}
  // ---------- DECISION ----------

  approveCard(applicantIndex: number) {
    this.loading=true
    this.getApplicants()
      .at(applicantIndex)
      .get('decision')
      .setValue('approved');

      this.getApplicants().at(applicantIndex).get('Users').disable()
      this.getApplicants().at(applicantIndex).get('makerRemarks').disable()
      setTimeout(() => {
        this.loading = false;
      }, 2000);
  }

  rejectCard(applicantIndex: number) {
    this.loading=true
    this.getApplicants()
      .at(applicantIndex)
      .get('decision')
      .setValue('rejected');

      this.getApplicants().at(applicantIndex).get('Users').disable()
      this.getApplicants().at(applicantIndex).get('makerRemarks').disable()
      setTimeout(() => {
        this.loading = false;
      }, 2000);
  }

  // ---------- CHECKER DECISION ----------

  

  checkerApproveCard(applicantIndex: number) {
    this.loading=true
    this.getApplicants()
      .at(applicantIndex)
      .get('checkerDecision')
      .setValue('approved');

      this.getApplicants().at(applicantIndex).get('Users').disable()
      this.getApplicants().at(applicantIndex).get('checkerRemarks').disable()
      setTimeout(() => {
        this.loading = false;
      }, 2000);
  }

  checkerRejectCard(applicantIndex: number) {
    this.loading=true
    this.getApplicants()
      .at(applicantIndex)
      .get('checkerDecision')
      .setValue('rejected');

      this.getApplicants().at(applicantIndex).get('Users').disable()
      this.getApplicants().at(applicantIndex).get('checkerRemarks').disable()
      setTimeout(() => {
        this.loading = false;
      }, 2000);
  }

  // ---------- PROCEED ----------

  allDecided(): boolean {

    const applicants = this.reviewableApplicants();

    // length check so an empty review cannot arm Proceed
    return applicants.length > 0 && applicants.every(applicant =>
      applicant.get('decision').value != null
    );

  }

  allCheckerDecided(): boolean {

    const applicants = this.reviewableApplicants();

    // length check so a failed load (empty form) cannot arm Proceed and post
    // an empty land_data
    return applicants.length > 0 && applicants.every(applicant =>
      applicant.get('checkerDecision').value != null
    );

  }

private buildLandData(role: 'maker' | 'checker') {

  const land_data = [];

  const isCheckerRole = role === 'checker';

  const decisionKey = isCheckerRole ? 'checkerDecision' : 'decision';
  const checkboxKey = isCheckerRole ? 'checkerIsChecked' : 'isChecked';
  const landAreaKey = isCheckerRole ? 'checkerEnteredLandArea' : 'enteredLandArea';
  const remarksKey  = isCheckerRole ? 'checkerRemarks' : 'makerRemarks';

  this.getApplicants().controls.forEach((applicant, applicantIndex) => {

    const file = this.apiFiles[applicantIndex];

    // Skip BRE-passed records: no verdict to report.
    if ((file.land_bre_status || "").toLowerCase() === "success") return;

    const decision = applicant.get(decisionKey).value;

    // ---------- current_data ----------
    const ownerDetails =
    file.ownershipdetails &&
    file.ownershipdetails.ownerDetails &&
    file.ownershipdetails.ownerDetails[0].ownerDetails
    ? file.ownershipdetails.ownerDetails[0].ownerDetails
    : [];

    const originalLandArea =
    ownerDetails.length > 0 ? Number(ownerDetails[0].hissa) : 0;
    const current_data = {
      isIrrigated: file.isIrrigated === true,
      isCourtCase: file.isCourtCase === true,
      isMortgage: file.isMortgage === true,
      landArea: originalLandArea,
      profile_match: file.name_match_details.profile_match > 0
    };

    let modified_data = { ...current_data };

    // ---------- if approved, apply modifications ----------
    if (decision === 'approved') {

      const users = this.getUsers(applicantIndex);

      users.controls.forEach(user => {

        if (!user.get('failed').value) return;

        const errorType = user.get('Error').value;
        const checked = user.get(checkboxKey).value;

        switch (errorType) {

          case 'name':
            if (checked)
              modified_data.profile_match = true;
            break;

          case 'land':
            const entered = Number(user.get(landAreaKey).value);
            if (!isNaN(entered))
              modified_data.landArea = entered > 10 ? 10 : entered;
            break;

          case 'court':
            if (checked)
              modified_data.isCourtCase = false;
            break;

          case 'irrigation':
            if (checked)
              modified_data.isIrrigated = true;
            break;

          case 'mortgage':
            if (checked)
              modified_data.isMortgage = false;
            break;

        }

      });

    }

    // ---------- current_status ----------
    const current_status =
      file.land_bre_status === "success" ? "success" : "failure";

    const record: any = {

      current_status,

      current_data,

      modified_data,

      recordTime: file.recordTime,

      overall_status: decision

    };

    record[remarksKey] = applicant.get(remarksKey).value || '';

    land_data.push(record);

  });

  return land_data;

}

// ---------- CONSENT DOCUMENTS ALREADY UPLOADED ----------

customerConsentDoc(): any {

  return this.consentDocs.find(doc => doc && doc.docType === 'review') || null;

}


makerConsentDoc(): any {

  return this.consentDocs.find(doc => doc && doc.docType === 'maker') || null;

}

// Fetches the document from /v1/mcu/getmcdocs and opens it in a new tab.

viewConsentDoc(doc: any): void {

  if (!doc || !doc.referenceId || this.openingDocRef) return;

  this.openingDocRef = doc.referenceId;

  this.authService.getConsentDoc(this.appId, doc.referenceId).subscribe(
    (res) => {

      this.openingDocRef = "";

      const result = res && res.result ? res.result : null;

      // Failures arrive as HTTP 200 with status:false, the same way the consent
      // submits do, so the flag decides this and not the status code.
      if (!(res && res.status === true && result && result.fileBase64)) {
        console.error("Consent document could not be fetched:", res);
        this.openConsentFailedDialog(
          this.consentErrorMessage(res) || "Could not open the document. Please try again."
        );
        return;
      }

      this.openBase64Pdf(result.fileBase64, result.fileName, result.fileType);

    },
    (err) => {
      this.openingDocRef = "";
      console.error("Could not fetch the consent document:", err);
      this.openConsentFailedDialog("Could not open the document. Please try again.");
    }
  );

}


private openBase64Pdf(base64: string, fileName?: string, fileType?: string): void {

  try {

    // The prefix is stripped if the backend sent one; atob chokes on it.
    const clean = String(base64).replace(/^data:[^;]*;base64,/, '');
    const byteChars = atob(clean);

    const bytes = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      bytes[i] = byteChars.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: fileType || 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const tab = window.open(url, '_blank');

    if (!tab) {

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'consent-document.pdf';
      link.click();

      // Given to the download before it is released; revoking straight away
      // can cancel it mid-save.
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;

    }

    // Revoked once the new tab has had time to load it; revoking immediately
    // leaves the tab with a dead URL.
    setTimeout(() => URL.revokeObjectURL(url), 60000);

  } catch (e) {
    console.error("Consent document is not valid base64:", e);
    this.openConsentFailedDialog("Could not open the document. Please try again.");
  }

}

// ---------- CONSENT DOCUMENT (MAKER UPLOAD) ----------

onConsentFileSelected(event: any): void {

  const input = event.target as HTMLInputElement;
  const file = input.files && input.files.length ? input.files[0] : null;

  // Cancelling the picker leaves whatever was already attached alone.
  if (!file) return;

  this.consentFile = null;
  this.consentFileError = "";

  if (file.type !== 'application/pdf') {
    this.consentFileError = "Only PDF files are allowed";
    input.value = '';
    return;
  }

  if (file.size > ValidationCardComponent.CONSENT_MAX_BYTES) {
    this.consentFileError = "Document size should not exceed 5MB";
    input.value = '';
    return;
  }

  this.consentFile = file;

}

removeConsentFile(fileInput: HTMLInputElement): void {

  this.consentFile = null;
  this.consentFileError = "";

  // Clear the native input too, or re-picking the same file fires no change
  // event and the field looks empty while the browser still holds it.
  if (fileInput) fileInput.value = '';

}

makerProceedCard() {

  // Mirrors the server's own requirement — no document, no submit.
  if (!this.consentFile) {
    this.consentFileError = "Please attach the consent document";
    return;
  }

  this.loading = true;
  this.checkerAction=true

  // The PDF goes up as base64 inside the JSON body, so it has to be read off
  // disk before anything can be sent. Nothing has reached the server yet at
  // this point, so a read failure leaves the application untouched.
  const reader = new FileReader();

  reader.onload = () => {
    this.submitMakerConsent(String(reader.result));
  };

  reader.onerror = () => {
    console.error("Could not read the consent document:", reader.error);
    this.loading = false;
    this.checkerAction = false;
    this.openConsentFailedDialog("Could not read the selected document. Please attach it again.");
  };

  // readAsDataURL, not readAsBinaryString: its "data:application/pdf;base64,"
  // prefix is stripped server-side, so the output is passed through as-is.
  reader.readAsDataURL(this.consentFile);

}

private submitMakerConsent(consentPdf: string): void {

  // ✅ FINAL REQUEST BODY
  // appId, maker_id and land_data are exactly what they always were — the
  // document is simply carried alongside them.
  const requestBody = {

    appId: this.appId,

    maker_id: sessionStorage.getItem("wl-admin-id"),

    land_data: this.buildLandData('maker'),

    consentPdf: consentPdf,

    // The server names and files the document itself; all it needs from here is
    // what kind of file it is.
    fileType: this.consentFile.type

  };

  // Logged without consentPdf — several megabytes of base64 in the console
  // helps nobody and hides the fields that matter.
  console.log("FINAL REQUEST BODY:", {
    appId: requestBody.appId,
    maker_id: requestBody.maker_id,
    land_data: requestBody.land_data,
    fileType: requestBody.fileType,
    consentPdf: `<base64, ${consentPdf.length} chars>`
  });

  // ✅ API call
  this.authService.getMakerConsent(requestBody).subscribe(
    (res) => {

      // Failures come back as HTTP 200 with status:false, so the flag is what
      // decides this, not the status code.
      if (!(res && res.status === true)) {
        console.error("Maker consent rejected:", res);
        this.loading = false;
        // Nothing was recorded — the document is stored before the case is
        // touched — so hand the screen back exactly as it is and let them
        // retry without re-entering a thing.
        this.checkerAction = false;
        this.openConsentFailedDialog(this.consentErrorMessage(res));
        return;
      }

      this.loading = false;
        sessionStorage.setItem('maker_id',sessionStorage.getItem("wl-admin-id"));
      console.log("Maker consent success:", res);

      // Confirm before leaving. openConsentResultDialog only returns to the
      // inbox once OK is pressed, so the popup replaces the silent 2s wait
      // this used to sit through — same as the checker's proceed.
      this.openConsentResultDialog("Maker consent submitted successfully");
    },
    (err) => {
      console.error("Maker consent error:", err);
      this.loading = false;
      // Hand the screen back untouched so the maker can submit again.
      this.checkerAction = false;
      this.openConsentFailedDialog();
    }
  );

}

// What to actually show the maker. `message` usually carries it, but the
// missing-document case answers message:"Failure" with the real reason in
// `error`, so that wins when it is there.
private consentErrorMessage(res: any): string {

  if (!res) return "";

  if (typeof res.error === 'string' && res.error) return res.error;

  if (typeof res.message === 'string' && res.message.toLowerCase() !== 'failure') {
    return res.message;
  }

  return "";

}
MakerClosedCard() {
        this.loading = true;

    setTimeout(() => {
        this.loading = false;
        this.router.navigate(['/fresh-app/view-review-journey']);
      }, 2000);
 }


checkerProceedCard(){

    this.loading = true;

    const payload = {
        appId: this.appId,
        checker_id: sessionStorage.getItem("wl-admin-id"),
        // "approved" is the checker's act of submitting the review, not a
        // verdict on the land: the per-record verdicts ride along in land_data,
        // including the case where every one of them was rejected.
        consentstatus: "approved",
        land_data: this.buildLandData('checker')
    }
     console.log("FINAL REQUEST BODY:", payload);
     this.checkerAction=true;
    this.authService.getCheckerConsent(payload).subscribe(resp=>{
        console.log("Checker consent response:", resp);
        this.loading = false;
        this.openConsentResultDialog(resp && resp.status === true
            ? "Checker consent submitted successfully"
            : (this.consentErrorMessage(resp) || "Could not submit the review."));

    },
    err=>{
        console.log("checker consent error",err);
        this.loading = false;
        this.checkerAction=false;
        this.openConsentFailedDialog();

    }
)
}

private openConsentResultDialog(message: string): void {

    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: '440px',
      disableClose: true,
      data: {
        heading: "",
        content: message,
        content1: "",
        button1Text: "OK",
        button2Text: ""
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/fresh-app/view-review-journey']);
    });

}

private openConsentFailedDialog(serverMessage: string = ""): void {

    this.dialog.open(OpenDialogYesOrNo, {
      width: '440px',
      data: {
        heading: "",
        content: serverMessage || "Could not submit the review.",
        content1: "Please press OK and try again.",
        button1Text: "OK",
        button2Text: ""
      }
    });

}

  allowOnlyNumberAndDecimal(event: KeyboardEvent): void {

    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);

    // Allow numbers
    if (/[0-9]/.test(char)) return;

    // Allow decimal point only once
    if (char === '.') {
      const input = event.target as HTMLInputElement;
      if (input.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    // Block everything else
    event.preventDefault();

  }

  // `control` is the field being typed into — enteredLandArea for the maker,
  // checkerEnteredLandArea for the checker — so the cleaned value is written
  // back to the form and not just to the DOM. Without that the control keeps
  // the raw keystrokes while the box on screen shows something else.
  validateLandAreaRange(event: any, control?: any): void {

  let value = event.target.value;

  // Remove invalid characters
  value = value.replace(/[^0-9.]/g, '');

  // Allow only one decimal
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts[1];
  }

  // A leading zero only means something in front of a decimal point: 0.5 is a
  // real area, 00 and 007 are not. Padding is collapsed as it is typed, so 00
  // and 000 can never be entered — "0" on its own survives only because it is
  // on the way to "0.5", and it leaves the field invalid until it gets there.
  if (/^0{2,}/.test(value) || /^0\d/.test(value)) {
    const stripped = value.replace(/^0+/, '');
    value = (stripped === '' || stripped.charAt(0) === '.') ? '0' + stripped : stripped;
  }

  // Convert to number
  const numericValue = Number(value);

  // Prevent values > 10
  if (numericValue > 10) {
    value = '10';
  }

  event.target.value = value;

  // Written back with an event so the confirmation checkbox re-evaluates —
  // that is what keeps a zero from being confirmed.
  if (control) {
    control.setValue(value, { emitEvent: true });
  }

}

}
